import React from 'react'
import { Avatar } from '@mui/material'
import classes from './StudentBox.module.css'

const StudentBox = ({
  student_avatar,
  student_name,
  student_grade,
  student_section,
  timetable,
  grade,
}) => {
  return (
    <div className={classes.bottombox}>
      {student_avatar ? (
        <img
          src={student_avatar}
          style={{
            width: '40px',
            height: '40px',
          }}
          alt=""
          className="employee-img"
        />
      ) : (
        <Avatar
          alt={''}
          sx={{
            width: '40px',
            height: '40px',
            mt: 0,
            fontSize: '18px',
            backgroundColor: '#F2ECF9',
            color: '#492972',
          }}
        >
          {grade ? student_name?.slice(-1)?.toUpperCase() : student_name?.charAt(0)?.toUpperCase()}
        </Avatar>
      )}
      <div className={classes.txtdiv}>
        <p className={classes.studenttxt}>{student_name}</p>
        {!grade && (
          <p className={`${classes.studentsubtxt} ${timetable ? classes.timetabletxt : ''}`}>
            Class: {student_grade}
            {student_section}
          </p>
        )}
      </div>
    </div>
  )
}

export default StudentBox
